import { render, staticRenderFns } from "./cooperationPerformance.vue?vue&type=template&id=95dad590&scoped=true&"
import script from "./cooperationPerformance.vue?vue&type=script&lang=js&"
export * from "./cooperationPerformance.vue?vue&type=script&lang=js&"
import style0 from "./cooperationPerformance.vue?vue&type=style&index=0&id=95dad590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dad590",
  null
  
)

export default component.exports